import Table from "@/components/Table"
import { ApiService } from "@/services/ApiService";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/Auth";
import { checkHasPermission } from "@/lib/permissions";
import { useNavigate } from "react-router-dom";

const Licenca = () => {
  const { t } = useTranslation()
  const { get } = ApiService
  const [apiData, setApiData] = useState([]);
  const { usuario } = useAuth();
  const navigate = useNavigate();
  
  const columns = [
    {
      header: t('table.licenca.head.identificador'),
      accessor: 'identificador',
    },
    {
      header: t('table.licenca.head.cliente'),
      accessor: 'clienteFormatado',
    },
    {
      header: t('table.licenca.head.status'),
      accessor: 'statusFormatado',
    },
    {
      header: t('table.licenca.head.tipoLicenca'),
      accessor: 'tipoLicencaFormatado',
    },
    {
      header: t('table.licenca.head.produto'),
      accessor: 'produto.nomeProduto',
    },
    {
      header: t('table.licenca.head.dataExpiracao'),
       accessor: 'dataDeExpiracao',
    },
    {
      header: t('table.licenca.head.dataHoraCadastro'),
      accessor: 'dataHoraCadastro',
    },
  ];

  const allowedActions = [];

  if (checkHasPermission(usuario?.permissoes, "ROLE_LICENCA_REGISTRAR")) {
    allowedActions.push("upload");
  }
  if (checkHasPermission(usuario?.permissoes, "ROLE_LICENCA_EDITAR")) {
    allowedActions.push("editar");
  }
  if (checkHasPermission(usuario?.permissoes, "ROLE_LICENCA_DELETAR")) {
    allowedActions.push("remover");
  }
  if (checkHasPermission(usuario?.permissoes, "ROLE_LICENCA_LISTAR")) {
    allowedActions.push("download");
  }
  if (checkHasPermission(usuario?.permissoes, "ROLE_LICENCA_EDITAR_FREQUENCIA")) {
    allowedActions.push("editar_frequencia");
  }

  const canAddNewLicence = checkHasPermission(usuario?.permissoes, "ROLE_LICENCA_REGISTRAR");

  function formatCnpj(cnpj: string) {
    return cnpj.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      "$1.$2.$3/$4-$5"
    );
  }

  const loadData = async () => {
    try {
      const { data } = await get("api/v1/licenca/listar");

      const formatted = data.map((item: any) => ({
        ...item,
        recursosCount: item.recursos ? item.recursos.length : 0,
        statusFormatado: t(`table.licenca.status.${item.status}`) || item.status,
        tipoLicencaFormatado: t(`table.licenca.tipoLicenca.${item.tipoLicenca}`) || item.tipoLicenca,
        dataHoraCadastro: new Date(item.dataHoraCadastro),
        dataDeExpiracao: new Date(item.dataDeExpiracao),
        clienteFormatado: {
          nome: item.cliente.nomeFantasia,
          cnpj: formatCnpj(item.cliente.cnpj)
        },
        clienteBusca: `${item.cliente.nomeFantasia} ${formatCnpj(item.cliente.cnpj)}`,
      }))
      .sort((a: any, b: any) => b.dataHoraCadastro - a.dataHoraCadastro);

      setApiData(formatted);
    } catch (error) {
      console.error("Erro ao carregar dados", error);
    }
  };

  useEffect(() => {
    loadData();
    
    const intervalId = setInterval(() => {
      loadData();
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className='flex-1 overflow-hidden p-8 max-md:px-4'>
      <div className="mb-8 border-b pb-4">
        <h1 className='text-3xl font-medium mb-8'>{t('home.title')}</h1>
      </div>
          <Table
            entity="licenca"
            baseRoute="api/v1/licenca"
            search={true}
            columns={columns}
            allowedActions={allowedActions}
            defaultData={apiData}
            buttonLabel={t("home.add-button")}
            onButtonClick={() => navigate("registrar-licenca")}
            isButtonDisabled={!canAddNewLicence}
            onRefresh={loadData}
          />
    </div>
  )
}

export default Licenca